// Old links never die: /destinations*, /destination/:id*, /connected-systems*
// all meant what the app now calls a Connection. Kept permanently (even after
// the legacy tree is deleted at sunset).
//
// Only the suffixes the old screens actually had are carried over; anything
// else was never a page there, so it is dropped instead of being forwarded
// into a fresh 404.
export const LEGACY_DESTINATION_SUFFIXES = ["configuration"];

export function legacyDestinationsTarget(pathname: string, search: string = ""): string {
    const [id, suffix] = pathname
        .replace(/^\/(connected-systems|destinations?)/, "")
        .split("/")
        .filter(Boolean);
    let target = "/connections";
    if (id) target += `/${id}`;
    if (id && suffix && LEGACY_DESTINATION_SUFFIXES.includes(suffix)) target += `/${suffix}`;
    return target + search;
}
